import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CallTypesService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @name getCallTypes
   * @description
   * @returns {Observable<any>}
   */
  getCallTypes() {
    return this._http
      .get(constant.URL_CALL_TYPE, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getCallTypeByID
   * @description
   * @param {number} id
   * @returns {Observable<any>}
   */
  getCallTypeByID(id: number): Observable<any> {
    return this._http
      .get(constant.URL_GET_CALL_TYPE + '/' + id, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name postData
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  postData(data: any): Observable<any> {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_CREATE_CALL_TYPE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putData
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  putData(data: any): Observable<any> {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_UPDATE_CALL_TYPE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));

  }

  /**
   * @name deleteData
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  deleteData(data: any): Observable<any> {
    return this._http.delete(`${constant.URL_DELETE_CALL_TYPE}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getSelectCapacityType() {
    return this._http
      .get(constant.URL_AUTO_ROUTING_CAPACITY_TYPES, this.getHeader())
      .map(res => res.json())
      .catch(error => this.validate401Error(error, this.route));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/call-types/call-types.service.ts